import { TuneOutlined } from '@mui/icons-material';
import { Button } from '@practium/ui';
import styles from './DemandAdjustmentBar.module.css';

interface DemandAdjustmentBarProps {
	selectedCount: number;
	isApplying: boolean;
	onAdjust: () => void;
}

export const DemandAdjustmentBar = ({
	selectedCount,
	isApplying,
	onAdjust,
}: DemandAdjustmentBarProps) => (
	<div className={styles.bar}>
		<div className={styles.summary}>
			<span className={styles.badge}>
				{selectedCount} {selectedCount === 1 ? 'mês' : 'meses'}
			</span>
			<span className={styles.text}>selecionados para ajuste com base na análise foliar</span>
		</div>
		<Button
			variant="primary"
			icon={<TuneOutlined />}
			onClick={onAdjust}
			disabled={!selectedCount}
			isLoading={isApplying}
			className={styles.button}
		>
			Ajustar demanda
		</Button>
	</div>
);
